import "./style.css";
import * as THREE from "three";
import { PointerLockControls } from "three/examples/jsm/controls/PointerLockControls";
import * as dat from "dat.gui";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import { gsap } from "gsap";
import { addCrossHair } from "../static/controls/CrossHair.js";
/**
 * Base
 */

let camera, scene, renderer, controls;

const gui = new dat.GUI({
  width: 400,
});

dat.GUI.toggleHide();

const objects = [];

let raycaster;
let currentIntersect = null;
let moveForward = false;
let moveBackward = false;
let moveLeft = false;
let moveRight = false;
let canJump = false;
let mixer = null;
// let mixer2 = null;

let prevTime = performance.now();
const velocity = new THREE.Vector3();
const direction = new THREE.Vector3();

/**
 * HTML Elements
 */
const blocker = document.getElementById("blocker");
const closebtn = document.getElementById("closebtn");
const closebtn2 = document.getElementById("closebtn2");
const closebtn3 = document.getElementById("closebtn3");
const closebtn4 = document.getElementById("closebtn4");
const closebtn5 = document.getElementById("closebtn5");
const closebtn6 = document.getElementById("closebtn6");
const closebtn7 = document.getElementById("closebtn7");
const closebtn8 = document.getElementById("closebtn8");
const closebtn9 = document.getElementById("closebtn9");
const closebtn10 = document.getElementById("closebtn10");
const closebtn11 = document.getElementById("closebtn11");
const closebtn12 = document.getElementById("closebtn12");
const closebtn13 = document.getElementById("closebtn13");
const closebtndirectory = document.getElementById("closebtn_directory");
const closebtnASM = document.getElementById("closebtn_asmBio");
const instructions2 = document.getElementById("instructions2");
const blockerdetails = document.getElementById("blockerdetails");
const collapsible = document.getElementById("collapsible_parent");
const mute = document.getElementById("mute");
const unmute = document.getElementById("unmute");
const asmdescription = document.getElementById("asmBio");
const directoryEnlarged = document.getElementById("directory");
const description1 = document.getElementById("farrahBio");
const description2 = document.getElementById("roopeshBio");
const description3 = document.getElementById("tasneemBio");
const description4 = document.getElementById("sukorBio");
const description5 = document.getElementById("hanifBio");
const description6 = document.getElementById("fazilBio");
const description7 = document.getElementById("ainolnaimBio");
const description8 = document.getElementById("limkokBio");
const description9 = document.getElementById("khairulBio");
const description10 = document.getElementById("shufitriBio");
const description11 = document.getElementById("hushinaidiBio");
const description12 = document.getElementById("shureenBio");
const description13 = document.getElementById("chuaBio");
const logotopleft = document.getElementById("logo");
const overlayUi1 = document.getElementById("farrah");
const overlayUi2 = document.getElementById("roopesh");
const overlayUi3 = document.getElementById("tasneem");
const overlayUi4 = document.getElementById("sukor");
const overlayUi5 = document.getElementById("hanif");
const overlayUi6 = document.getElementById("fazil");
const overlayUi7 = document.getElementById("ainolnaim");
const overlayUi8 = document.getElementById("OverlaylimKokYong8");
const overlayUi9 = document.getElementById("khairul");
const overlayUi10 = document.getElementById("shufitri");
const overlayUi11 = document.getElementById("hushinaidi");
const overlayUi12 = document.getElementById("shureen");
const overlayUi13 = document.getElementById("chua");
const overlayUiAsm = document.getElementById("asm");

/**
 * Toggle Check
 */
let toggleasmdescription = false;
let toggleddirectory = false;
let toggledescription1 = false;
let toggledescription2 = false;
let toggledescription3 = false;
let toggledescription4 = false;
let toggledescription5 = false;
let toggledescription6 = false;
let toggledescription7 = false;
let toggledescription8 = false;
let toggledescription9 = false;
let toggledescription10 = false;
let toggledescription11 = false;
let toggledescription12 = false;
let toggledescription13 = false;

const clock = new THREE.Clock();
let previousTime = 0;
let gateOpen = false;

const mouse = new THREE.Vector2();
document.addEventListener("movemouse", () => {
  mouse.x = (MouseEvent.clientX / window.innerWidth) * 2 - 1;
  mouse.y = (MouseEvent.clientY / window.innerHeight) * 2 + 1;
});

init();
animate();

function init() {
  const canvas = document.getElementById("canvas-bg");

  camera = new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    1,
    2000
  );
  camera.position.y = 10;
  camera.position.z = 140;
  camera.position.x = 10;
  addCrossHair(camera);
  // create an AudioListener and add it to the camera
  const listener = new THREE.AudioListener();
  camera.add(listener);

  // create a global audio source
  const sound = new THREE.Audio(listener);

  // load a sound and set it as the Audio object's buffer
  const audioLoader = new THREE.AudioLoader();
  audioLoader.load("../video/ambient.mp3", function (buffer) {
    sound.setBuffer(buffer);
    sound.setLoop(true);
    sound.setVolume(0.05);
  });

  mute.addEventListener("click", () => {
    sound.setVolume(0);
  });

  unmute.addEventListener("click", () => {
    sound.setVolume(0.05);
  });

  THREE.DefaultLoadingManager.onProgress = function (x, y, z) {
    document.querySelector("#loader span").textContent = `${Math.floor(
      (y / z) * 100
    )}% Loading...`;
  };

  THREE.DefaultLoadingManager.onLoad = function () {
    console.log("items loaded");

    const loadingScreen = document.getElementById("loading");
    loadingScreen.style.zIndex = "1";
    loadingScreen.classList.add("fade-out");
    loadingScreen.addEventListener("transitionend", onTransitionEnd);
  };

  function onTransitionEnd(event) {
    event.target.remove();
  }

  scene = new THREE.Scene();
  scene.background = new THREE.Color(0x000000);
  scene.fog = new THREE.Fog(0xffffff, 0, 750);
  const textureLoader = new THREE.TextureLoader();
  const glowTexture = textureLoader.load("../textures/Glow.png");
  const directoryText = textureLoader.load("../textures/directory_text.jpg");
  // const asmVid = textureLoader.load("../video/asm.mp4");

  /**
   * VIDEO TEXTURES
   */
   const videoasm = document.getElementById("videoasm");
   const videoTextureasm = new THREE.VideoTexture(videoasm);
   videoasm.src = "../video/asm.mp4";

  const video1 = document.getElementById("video1");
  const videoTexture1 = new THREE.VideoTexture(video1);
  video1.src = "../video/video1.mp4";

  const video2 = document.getElementById("video2");
  const videoTexture2 = new THREE.VideoTexture(video2);
  video2.src = "../video/video2.mp4";

  const video3 = document.getElementById("video3");
  const videoTexture3 = new THREE.VideoTexture(video3);
  video3.src = "../video/video3.mp4";

  const video4 = document.getElementById("video4");
  const videoTexture4 = new THREE.VideoTexture(video4);
  video4.src = "../video/video4.mp4";

  const video5 = document.getElementById("video5");
  const videoTexture5 = new THREE.VideoTexture(video5);
  video5.src = "../video/video5.mp4";

  const video6 = document.getElementById("video6");
  const videoTexture6 = new THREE.VideoTexture(video6);
  video6.src = "../video/video6.mp4";

  const video7 = document.getElementById("video7");
  const videoTexture7 = new THREE.VideoTexture(video7);
  video7.src = "../video/video7.mp4";

  const video8 = document.getElementById("video8");
  const videoTexture8 = new THREE.VideoTexture(video8);
  video8.src = "../video/video8.mp4";

  const video9 = document.getElementById("video9");
  const videoTexture9 = new THREE.VideoTexture(video9);
  video9.src = "../video/video9.mp4";

  const video10 = document.getElementById("video10");
  const videoTexture10 = new THREE.VideoTexture(video10);
  video10.src = "../video/video10.mp4";

  const video11 = document.getElementById("video11");
  const videoTexture11 = new THREE.VideoTexture(video11);
  video11.src = "../video/video11.mp4";

  const video12 = document.getElementById("video12");
  const videoTexture12 = new THREE.VideoTexture(video12);
  video12.src = "../video/video12.mp4";

  const video13 = document.getElementById("video13");
  const videoTexture13 = new THREE.VideoTexture(video13);
  video13.src = "../video/video13.mp4";

  const light = new THREE.HemisphereLight(0xeeeeff, 0x777788, 1);
  light.position.set(0, 0.5, 2);
  scene.add(light);

  controls = new PointerLockControls(camera, document.body);

  window.addEventListener("click", () => {
    if (currentIntersect) {
      sound.pause();
      console.log("tekan");
      controls.unlock();
      currentIntersect = null;
    }
    dontdisplayUi();
  });

  instructions2.addEventListener("click", function () {
    currentIntersect = null;
    controls.lock();
    videoasm.play();
    video1.play();
    video2.play();
    video3.play();
    video4.play();
    video5.play();
    video6.play();
    video7.play();
    video8.play();
    video9.play();
    video10.play();
    video11.play();
    video12.play();
    video13.play();
    sound.play();
    console.log("OpenGate.");
    onClick();

    gateOpen = true;
  });

  
  closebtn.addEventListener("click", function () {
    controls.lock();
    sound.play();
    console.log("click closebtn");
  });
  // description1.addEventListener("click", function () {
  //   controls.lock();
  // });
  closebtn2.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn3.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn4.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn5.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn6.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn7.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn8.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn9.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn10.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn11.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn12.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtn13.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtndirectory.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  closebtnASM.addEventListener("click", function () {
    controls.lock();
    sound.play();
  });
  
  

  controls.addEventListener("lock", function () {
    blocker.style.display = "none";

    instructions2.style.display = "none";
    blockerdetails.style.display = "none";
    collapsible.style.display = "none";
    asmdescription.style.display = "none";
    directoryEnlarged.style.display = "none";
    logotopleft.style.display = "none";
    description1.style.display = "none";
    description2.style.display = "none";
    description3.style.display = "none";
    description4.style.display = "none";
    description5.style.display = "none";
    description6.style.display = "none";
    description7.style.display = "none";
    description8.style.display = "none";
    description9.style.display = "none";
    description10.style.display = "none";
    description11.style.display = "none";
    description12.style.display = "none";
    description13.style.display = "none";
  });

  window.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.keyCode == 27) {
      blocker.style.display = "block";

      instructions2.style.display = "flex";
      blockerdetails.style.display = "flex";
      collapsible.style.display = "block";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";

      logotopleft.style.display = "none";
      description1.style.display = "none";
      description2.style.display = "none";
      description8.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
      dontdisplayUi();
      console.log("EscPressed");
    }
  };

  controls.addEventListener("unlock", function () {
    dontdisplayUi();
    if (toggleasmdescription == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "flex";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription1 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "flex";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription2 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "flex";
      description8.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription3 == true) {
      blocker.style.display = "block";
      console.log("tasneem");
      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "flex";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription4 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      logotopleft.style.display = "block";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "flex";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription5 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "flex";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription6 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "flex";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription7 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "flex";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription8 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "flex";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription9 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "flex";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription10 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "flex";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription11 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "flex";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (toggledescription12 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "flex";
      description13.style.display = "none";
    } else if (toggledescription13 == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "flex";
    }
    else if (toggleddirectory == true) {
      blocker.style.display = "block";

      instructions2.style.display = "none";
      blockerdetails.style.display = "none";
      collapsible.style.display = "none";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "flex";
      logotopleft.style.display = "block";
      description1.style.display = "none";
      description2.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
    } else if (
      toggleasmdescription == false &&
      toggledescription1 == false &&
      toggledescription2 == false &&
      toggledescription3 == false &&
      toggledescription4 == false &&
      toggledescription5 == false &&
      toggledescription6 == false &&
      toggledescription7 == false &&
      toggledescription8 == false &&
      toggledescription9 == false &&
      toggledescription10 == false &&
      toggledescription11 == false &&
      toggledescription12 == false &&
      toggledescription13 == false
    ) {
      blocker.style.display = "block";

      instructions2.style.display = "flex";
      blockerdetails.style.display = "flex";
      collapsible.style.display = "block";
      asmdescription.style.display = "none";
      directoryEnlarged.style.display = "none";

      logotopleft.style.display = "none";
      description1.style.display = "none";
      description2.style.display = "none";
      description8.style.display = "none";
      description3.style.display = "none";
      description4.style.display = "none";
      description5.style.display = "none";
      description6.style.display = "none";
      description7.style.display = "none";
      description8.style.display = "none";
      description9.style.display = "none";
      description10.style.display = "none";
      description11.style.display = "none";
      description12.style.display = "none";
      description13.style.display = "none";
      console.log("displayinstruction");
    }
  });

  scene.add(controls.getObject());

  const onKeyDown = function (event) {
    switch (event.code) {
      case "ArrowUp":
      case "KeyW":
        moveForward = true;
        break;

      case "ArrowLeft":
      case "KeyA":
        moveLeft = true;
        break;

      case "ArrowDown":
      case "KeyS":
        moveBackward = true;
        break;

      case "ArrowRight":
      case "KeyD":
        moveRight = true;
        break;

      case "Space":
        if (canJump === true) velocity.y += 350;
        canJump = false;
        break;
    }
  };

  const onKeyUp = function (event) {
    switch (event.code) {
      case "ArrowUp":
      case "KeyW":
        moveForward = false;
        break;

      case "ArrowLeft":
      case "KeyA":
        moveLeft = false;
        break;

      case "ArrowDown":
      case "KeyS":
        moveBackward = false;
        break;

      case "ArrowRight":
      case "KeyD":
        moveRight = false;
        break;
    }
  };

  document.addEventListener("touchstart", function () {
    console.log("touch");
    moveForward = true;
  });
  document.addEventListener("touchend", function () {
    console.log("end");
    moveForward = false;
  });

  document.addEventListener("keydown", onKeyDown, false);
  document.addEventListener("keyup", onKeyUp, false);

  raycaster = new THREE.Raycaster(
    new THREE.Vector3(),
    new THREE.Vector3(0, -1, 0),
    0,
    150
  );
  // new THREE.Vector3(),
  // new THREE.Vector3(0, -1, 0),
  // 0,
  // 10

  // Art Screen Materials

  //Poster
  const screen = new THREE.PlaneGeometry(50, 30);
  // const screenPoster = new THREE.PlaneGeometry(20, 40);
  const glowMaterial = new THREE.MeshBasicMaterial({
    color: 0xfff996,
    map: glowTexture,
    side: THREE.DoubleSide,
    toneMapped: false,
    transparent: true,
    alphaMap: glowTexture,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
  });

  const glowScreen = new THREE.Mesh(screen, glowMaterial);
  glowScreen.scale.set(1.17, 1.3, 1.2);
  glowScreen.position.x = 7.1;
  glowScreen.position.y = 15;
  glowScreen.position.z = -266.4;

  //Directory
  const directoryMaterial = new THREE.MeshBasicMaterial({

    map: directoryText,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const asmMaterial = new THREE.MeshBasicMaterial({
    map: videoTextureasm,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const directoryScreen = new THREE.Mesh(screen, directoryMaterial);
  directoryScreen.position.x = -100;
  directoryScreen.position.y = 10;
  directoryScreen.position.z = -40.4;
  directoryScreen.rotation.y = -11.5;
  directoryScreen.name = "directory";

  const asmpanel = new THREE.Mesh(screen, asmMaterial);
  asmpanel.position.x = 74.2;
  asmpanel.position.y = 55;
  asmpanel.position.z = -200.1;
  asmpanel.rotation.y = -89.7;
  asmpanel.name = "asmui";

  //ArtVideo Material

  const videoMaterial1 = new THREE.MeshBasicMaterial({
    map: videoTexture1,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial2 = new THREE.MeshBasicMaterial({
    map: videoTexture2,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial3 = new THREE.MeshBasicMaterial({
    map: videoTexture3,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial4 = new THREE.MeshBasicMaterial({
    map: videoTexture4,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial5 = new THREE.MeshBasicMaterial({
    map: videoTexture5,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial6 = new THREE.MeshBasicMaterial({
    map: videoTexture6,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial7 = new THREE.MeshBasicMaterial({
    map: videoTexture7,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial8 = new THREE.MeshBasicMaterial({
    map: videoTexture8,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial9 = new THREE.MeshBasicMaterial({
    map: videoTexture9,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial10 = new THREE.MeshBasicMaterial({
    map: videoTexture10,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial11 = new THREE.MeshBasicMaterial({
    map: videoTexture11,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial12 = new THREE.MeshBasicMaterial({
    map: videoTexture12,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  const videoMaterial13 = new THREE.MeshBasicMaterial({
    map: videoTexture13,
    side: THREE.DoubleSide,
    toneMapped: false,
  });

  //ArtVideo Mesh Position
  const videoScreen = new THREE.Mesh(screen, videoMaterial1);
  videoScreen.position.x = -55;
  videoScreen.position.y = 70;
  videoScreen.position.z = -343.5;
  videoScreen.rotation.y = -11;
  videoScreen.name = "box1";

  const videoScreen1 = new THREE.Mesh(screen, videoMaterial2);
  videoScreen1.position.x = 17.8;
  videoScreen1.position.y = 2;
  videoScreen1.position.z = -352;
  videoScreen1.rotation.y = 29.78;
  videoScreen1.name = "box2";

  const videoScreen2 = new THREE.Mesh(screen, videoMaterial3);
  videoScreen2.position.x = 79.6;
  videoScreen2.position.y = 15;
  videoScreen2.position.z = -290.5;
  videoScreen2.rotation.y = 14.4;
  videoScreen2.name = "box3";

  const videoScreen3 = new THREE.Mesh(screen, videoMaterial4);
  videoScreen3.position.x = -72.6;
  videoScreen3.position.y = 70;
  videoScreen3.position.z = -150;
  videoScreen3.rotation.y = 17.6;
  videoScreen3.name = "box4";

  const videoScreen4 = new THREE.Mesh(screen, videoMaterial5);
  videoScreen4.scale.set(1, 1, 1);
  videoScreen4.position.x = 7.1;
  videoScreen4.position.y = 15;
  videoScreen4.position.z = -266.3;
  videoScreen4.rotation.y = 0;
  videoScreen4.name = "box5";

  function onClick() {
    gsap.to(videoScreen4.scale, {
      duration: 1,
      x: 1.1,
      y: 1.1,
      z: 1.1,
      repeat: -1,
      yoyo: true,
    });

    gsap.to(glowScreen.scale, {
      duration: 1,
      x: 1.27,
      y: 1.4,
      z: 1.3,
      repeat: -1,
      yoyo: true,
    });
  }

  const videoScreen5 = new THREE.Mesh(screen, videoMaterial6);
  videoScreen5.position.x = 9;
  videoScreen5.position.y = 60;
  videoScreen5.position.z = -171.6;
  videoScreen5.rotation.y = 29.97;
  videoScreen5.name = "box6";

  const videoScreen6 = new THREE.Mesh(screen, videoMaterial7);
  videoScreen6.position.x = -57;
  videoScreen6.position.y = 2;
  videoScreen6.position.z = -281.7;
  videoScreen6.rotation.y = 1.83;
  videoScreen6.name = "box7";

  const videoScreen7 = new THREE.Mesh(screen, videoMaterial8);
  videoScreen7.position.x = -40;
  videoScreen7.position.y = 2;
  videoScreen7.position.z = -164.6;
  videoScreen7.rotation.y = -23.49;
  videoScreen7.name = "box8";

  const videoScreen8 = new THREE.Mesh(screen, videoMaterial9);
  videoScreen8.position.x = -100;
  videoScreen8.position.y = 2;
  videoScreen8.position.z = -334.7;
  videoScreen8.rotation.y = -29.7;
  videoScreen8.name = "box9";

  const videoScreen9 = new THREE.Mesh(screen, videoMaterial10);
  videoScreen9.position.x = 74.2;
  videoScreen9.position.y = 2;
  videoScreen9.position.z = -211.1;
  videoScreen9.rotation.y = -89.7;
  videoScreen9.name = "box10";

  const videoScreen10 = new THREE.Mesh(screen, videoMaterial11);
  videoScreen10.position.x = -24.1;
  videoScreen10.position.y = 15;
  videoScreen10.position.z = -400;
  videoScreen10.rotation.y = -4.8;
  videoScreen10.name = "box11";

  const videoScreen11 = new THREE.Mesh(screen, videoMaterial12);
  videoScreen11.position.x = 48.7;
  videoScreen11.position.y = 70;
  videoScreen11.position.z = -352.3;
  videoScreen11.rotation.y = -1.5;
  videoScreen11.name = "box12";

  const videoScreen12 = new THREE.Mesh(screen, videoMaterial13);
  videoScreen12.position.x = -100;
  videoScreen12.position.y = 15;
  videoScreen12.position.z = -219;
  videoScreen12.rotation.y = 20.6;
  videoScreen12.name = "box13";

  //Brain materials
  const materialmark2 = new THREE.MeshBasicMaterial({
    // color: 0x000fff,
    opacity: 0.2,
    transparent: true,
    wireframe: true,
  });

  const materialmark3 = new THREE.MeshBasicMaterial({
    transparent: true,
    opacity: 0.02,
    blending: THREE.AdditiveBlending,
    wireframe: true,
  });

  scene.add(
    videoScreen,
    videoScreen1,
    videoScreen2,
    videoScreen3,
    videoScreen4,
    videoScreen5,
    videoScreen6,
    videoScreen7,
    videoScreen8,
    videoScreen9,
    videoScreen10,
    videoScreen11,
    videoScreen12,
    glowScreen,
    directoryScreen,
    asmpanel
  );
  objects.push(
    videoScreen,
    videoScreen1,
    videoScreen2,
    videoScreen3,
    videoScreen4,
    videoScreen5,
    videoScreen6,
    videoScreen7,
    videoScreen8,
    videoScreen9,
    videoScreen10,
    videoScreen11,
    videoScreen12,
    directoryScreen,
    asmpanel
  );

  videoasm.loop = true;
  video1.loop = true;
  video2.loop = true;
  video3.loop = true;
  video4.loop = true;
  video5.loop = true;
  video6.loop = true;
  video7.loop = true;
  video8.loop = true;
  video9.loop = true;
  video10.loop = true;
  video11.loop = true;
  video12.loop = true;
  video13.loop = true;

  /**
   * Debug Uis
   */
  //VideoScreen
  const VideoScreen1 = gui.addFolder("Screen1");
  VideoScreen1.add(videoScreen.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen1.add(videoScreen.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen1.add(videoScreen.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen1.add(videoScreen.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.0001)
    .name("VideoScreenRotationY");
  const VideoScreen2 = gui.addFolder("Screen2");
  VideoScreen2.add(videoScreen1.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen2.add(videoScreen1.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen2.add(videoScreen1.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen2.add(videoScreen1.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen3 = gui.addFolder("Screen3");
  VideoScreen3.add(videoScreen2.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen3.add(videoScreen2.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen3.add(videoScreen2.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen3.add(videoScreen2.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen4 = gui.addFolder("Screen4");
  VideoScreen4.add(videoScreen3.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen4.add(videoScreen3.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen4.add(videoScreen3.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen4.add(videoScreen3.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen5 = gui.addFolder("Screen5");
  VideoScreen5.add(videoScreen4.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen5.add(videoScreen4.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen5.add(videoScreen4.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen5.add(videoScreen4.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen6 = gui.addFolder("Screen6");
  VideoScreen6.add(videoScreen5.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen6.add(videoScreen5.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen6.add(videoScreen5.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen6.add(videoScreen5.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen7 = gui.addFolder("Screen7");
  VideoScreen7.add(videoScreen6.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen7.add(videoScreen6.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen7.add(videoScreen6.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen7.add(videoScreen6.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen8 = gui.addFolder("Screen8");
  VideoScreen8.add(videoScreen7.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen8.add(videoScreen7.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen8.add(videoScreen7.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen8.add(videoScreen7.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen9 = gui.addFolder("Screen9");
  VideoScreen9.add(videoScreen8.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen9.add(videoScreen8.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen9.add(videoScreen8.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen9.add(videoScreen8.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen10 = gui.addFolder("Screen10");
  VideoScreen10.add(videoScreen9.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen10.add(videoScreen9.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen10.add(videoScreen9.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen10.add(videoScreen9.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen11 = gui.addFolder("Screen11");
  VideoScreen11.add(videoScreen10.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen11.add(videoScreen10.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen11.add(videoScreen10.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen11.add(videoScreen10.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen12 = gui.addFolder("Screen12");
  VideoScreen12.add(videoScreen11.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen12.add(videoScreen11.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen12.add(videoScreen11.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen12.add(videoScreen11.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");
  const VideoScreen13 = gui.addFolder("Screen13");
  VideoScreen13.add(videoScreen12.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
  VideoScreen13.add(videoScreen12.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
  VideoScreen13.add(videoScreen12.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
  VideoScreen13.add(videoScreen12.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");


  const directoryScreen1 = gui.addFolder("directoryScreen1");
  directoryScreen1.add(directoryScreen.position, "x")
    .min(-100)
    .max(100)
    .step(0.1)
    .name("VideoScreenX");
    directoryScreen1.add(directoryScreen.position, "y")
    .min(-3)
    .max(100)
    .step(0.1)
    .name("VideoScreenY");
    directoryScreen1.add(directoryScreen.position, "z")
    .min(-400)
    .max(400)
    .step(0.1)
    .name("VideoScreenZ");
    directoryScreen1.add(directoryScreen.rotation, "y")
    .min(-100)
    .max(100)
    .step(0.01)
    .name("VideoScreenRotationY");

  const loader = new GLTFLoader();

  // const loader2 = new FBXLoader();

  // loader2.load(
  //   "../models/brainVFX3.fbx",
  //   function (object) {
  //     mixer2 = new THREE.AnimationMixer(object);

  //     const action2 = mixer2.clipAction(object.animations[0]);
  //     action2.play();

  //     object.scale.set(0.4, 0.4, 0.4);
  //     object.position.set(-25, -30, -260);
  //     object.rotation.set(0, -80, 0);

  //     object.traverse((node) => {
  //       if (!node.isMesh) return;
  //       node.material = materialmark3;
  //     });

  //     scene.add(object);
  //   },
  //   // called while loading is progressing
  //   function (xhr) {
  //     console.log((xhr.loaded / xhr.total) * 100 + "% fbx loaded");
  //   },
  //   // called when loading has errors
  //   function (error) {
  //     console.log("An error happened");
  //   }
  // );
  // Load a glTF resource
  loader.load(
    // resource URL
    "../models/braindead.glb",
    // called when the resource is loaded
    function (gltf) {
      const root = gltf.scene;
      root.scale.set(1.5, 1.5, 1.5);
      root.position.set(8.4, 40, -190);
      root.rotation.set(0, 67.59, 0);
      root.traverse((node) => {
        if (!node.isMesh) return;
        node.material = materialmark2;
      });

      const BrainPos = gui.addFolder("Brain");
      BrainPos.add(root.position, "x")
        .min(-100)
        .max(100)
        .step(0.1)
        .name("VideoScreenX");
      BrainPos.add(root.position, "y")
        .min(-3)
        .max(100)
        .step(0.1)
        .name("VideoScreenY");
      BrainPos.add(root.position, "z")
        .min(-400)
        .max(400)
        .step(0.1)
        .name("VideoScreenZ");
      BrainPos.add(root.rotation, "y")
        .min(-100)
        .max(100)
        .step(0.01)
        .name("VideoScreenRotationY");

      scene.add(root);
    },

    // called while loading is progressing
    function (xhr) {
      console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
    },
    // called when loading has errors
    function (error) {
      console.log("An error happened");
    }
  );

  loader.load(
    "../models/gateanimated3.glb",
    function (gltf2) {
      const root2 = gltf2.scene;
      root2.scale.set(30, 30, 30);
      root2.position.set(9.7, -30, 70);
      root2.rotation.set(0, -139.8, 0);
      root2.traverse((node) => {
        if (!node.isMesh) return;
        node.material.wireframe = true;
      });

      const GatePos = gui.addFolder("Gate");
      GatePos.add(root2.position, "x")
        .min(-100)
        .max(100)
        .step(0.1)
        .name("VideoScreenX");
      GatePos.add(root2.position, "y")
        .min(-3)
        .max(100)
        .step(0.1)
        .name("VideoScreenY");
      GatePos.add(root2.position, "z")
        .min(-400)
        .max(400)
        .step(0.1)
        .name("VideoScreenZ");
      GatePos.add(root2.rotation, "y")
        .min(-360)
        .max(360)
        .step(0.00001)
        .name("VideoScreenRotationY");

      scene.add(root2);

      mixer = new THREE.AnimationMixer(gltf2.scene);
      const action = mixer.clipAction(gltf2.animations[1]);
      const action2 = mixer.clipAction(gltf2.animations[0]);
      action.clampWhenFinished = true;
      action.setLoop(THREE.LoopOnce);
      action.play();
      action2.clampWhenFinished = true;
      action2.setLoop(THREE.LoopOnce);
      action2.play();
      // console.log("test")
    },
    // called while loading is progressing
    function (xhr) {
      console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
    },
    // called when loading has errors
    function (error) {
      console.log("An error happened");
      // do something with part_2
    }
  );

  renderer = new THREE.WebGLRenderer({
    antialias: true,
    canvas,
  });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(window.innerWidth, window.innerHeight);
  document.body.appendChild(renderer.domElement);

  //

  window.addEventListener("resize", onWindowResize);
}

function displayUi1() {
  console.log("farrahhover");
  overlayUi1.style.display = "block";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi2() {
  console.log("roopeshhover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "block";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi3() {
  console.log("mayhover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "block";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi4() {
  console.log("sukorhover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "block";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi5() {
  console.log("hanifhover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "block";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi6() {
  console.log("fazilhover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "block";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi7() {
  console.log("ainolhover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "block";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi8() {
  console.log("kyhover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "block";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi9() {
  console.log("khairul");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "block";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi10() {
  console.log("shufitrihover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "block";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi11() {
  console.log("hushinaidihover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "block";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi12() {
  console.log("shureenhover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "block";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function displayUi13() {
  console.log("chuahover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "block";
  overlayUiAsm.style.display = "none";
}

function displayUiASM() {
  console.log("chuahover");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "block";
}

function dontdisplayUi() {
  console.log("dontdisplayUi");
  overlayUi1.style.display = "none";
  overlayUi2.style.display = "none";
  overlayUi3.style.display = "none";
  overlayUi4.style.display = "none";
  overlayUi5.style.display = "none";
  overlayUi6.style.display = "none";
  overlayUi7.style.display = "none";
  overlayUi8.style.display = "none";
  overlayUi9.style.display = "none";
  overlayUi10.style.display = "none";
  overlayUi11.style.display = "none";
  overlayUi12.style.display = "none";
  overlayUi13.style.display = "none";
  overlayUiAsm.style.display = "none";
}

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();

  renderer.setSize(window.innerWidth, window.innerHeight);
}

function animate() {
  requestAnimationFrame(animate);

  const time = performance.now();
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  if (gateOpen == true) {
    if (mixer) {
      mixer.update(deltaTime);
      mixer.timeScale = 0.5;
    }
  }

  // if (mixer2) {
  //   mixer2.update(deltaTime);
  // }

  if (controls.isLocked === true) {
    // raycaster.ray.origin.copy(controls.getObject().position);
    raycaster.setFromCamera(mouse, camera);

    // raycaster.ray.origin.y += 5;

    const intersects = raycaster.intersectObjects(objects);
    if (intersects.length > 0) {
      for (var i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name == "box1") {
          if (!currentIntersect) {
            displayUi1();
            toggleasmdescription = false;
            toggledescription1 = true;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("farrah");
            console.log("box1");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box2") {
          if (!currentIntersect) {
            displayUi2();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = true;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("roopesh");
            console.log("box2");
            console.log("mouse enter");
          }

          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box3") {
          if (!currentIntersect) {
            displayUi3();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = true;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("maytasneem");
            console.log("box3");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box4") {
          if (!currentIntersect) {
            displayUi4();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = true;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("sukor");
            console.log("box4");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box5") {
          if (!currentIntersect) {
            displayUi5();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = true;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("hanif");
            console.log("box5");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box6") {
          if (!currentIntersect) {
            displayUi6();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = true;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("fazil");
            console.log("box6");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box7") {
          if (!currentIntersect) {
            displayUi7();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = true;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("ainolnaim");
            console.log("box7");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box8") {
          if (!currentIntersect) {
            displayUi8();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = true;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("limkokyong");
            console.log("box8");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box9") {
          if (!currentIntersect) {
            displayUi9();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = true;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("khairul");
            console.log("box9");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box10") {
          if (!currentIntersect) {
            displayUi10();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = true;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("shufitri");
            console.log("box10");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box11") {
          if (!currentIntersect) {
            displayUi11();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = true;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("hushinaidi");
            console.log("box11");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box12") {
          if (!currentIntersect) {
            displayUi12();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = true;
            toggledescription13 = false;
            console.log("shureen");
            console.log("box12");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "box13") {
          if (!currentIntersect) {
            displayUi13();
            toggleasmdescription = false;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = true;
            console.log("chuah");
            console.log("box13");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        } else if (intersects[i].object.name == "directory") {
          if (!currentIntersect) {
            toggleasmdescription = false;
            toggleddirectory = true;
            toggledescription1 = false;
            toggledescription2 = false;
            toggledescription3 = false;
            toggledescription4 = false;
            toggledescription5 = false;
            toggledescription6 = false;
            toggledescription7 = false;
            toggledescription8 = false;
            toggledescription9 = false;
            toggledescription10 = false;
            toggledescription11 = false;
            toggledescription12 = false;
            toggledescription13 = false;
            console.log("directory");
            console.log("mouse enter");
          }
          currentIntersect = intersects[0];
        }
      else if (intersects[i].object.name == "asmui") {
      if (!currentIntersect) {
        displayUiASM()
        toggleasmdescription = true;
        toggleddirectory = false;
        toggledescription1 = false;
        toggledescription2 = false;
        toggledescription3 = false;
        toggledescription4 = false;
        toggledescription5 = false;
        toggledescription6 = false;
        toggledescription7 = false;
        toggledescription8 = false;
        toggledescription9 = false;
        toggledescription10 = false;
        toggledescription11 = false;
        toggledescription12 = false;
        toggledescription13 = false;
        console.log("asmui");
        console.log("mouse enter");
      }
      currentIntersect = intersects[0];
    }
  }
}
     else {
      if (currentIntersect) {
        console.log("leave");
        dontdisplayUi();
        // blocker.style.display = "none";
        // instructions2.style.display = "none";
        // blockerdetails.style.display = "none";
        // description8.style.display = "none";
        // asmdescription.style.display = "none";
        // description2.style.display = "none";
        toggleasmdescription = false;
        toggleddirectory = false;
        toggledescription1 = false;
        toggledescription2 = false;
        toggledescription3 = false;
        toggledescription4 = false;
        toggledescription5 = false;
        toggledescription6 = false;
        toggledescription7 = false;
        toggledescription8 = false;
        toggledescription9 = false;
        toggledescription10 = false;
        toggledescription11 = false;
        toggledescription12 = false;
        toggledescription13 = false;
      }

      currentIntersect = null;
    }

    const delta = (time - prevTime) / 1000;

    velocity.x -= velocity.x * 10.0 * delta;
    velocity.z -= velocity.z * 10.0 * delta;

    // velocity.y -= 9.8 * 100.0 * delta; // 100.0 = mass

    direction.z = Number(moveForward) - Number(moveBackward);
    direction.x = Number(moveRight) - Number(moveLeft);
    direction.normalize(); // this ensures consistent movements in all directions

    if (moveForward || moveBackward) velocity.z -= direction.z * 400.0 * delta;
    if (moveLeft || moveRight) velocity.x -= direction.x * 400.0 * delta;

    controls.moveRight(-velocity.x * delta);
    controls.moveForward(-velocity.z * delta);

    controls.getObject().position.y += velocity.y * delta; // new behavior
  }

  prevTime = time;

  renderer.render(scene, camera);
}
